import React, { useState } from "react";
import { parse, addYears } from "date-fns";
import { Flex, Grid, GridItem, Icon, Text, Tooltip } from "@chakra-ui/react";

import { Group } from "../../Group";
import { CustomDatepickerWField } from "../../../../components/CustomDatepickerWField";
import { CustomSelectWField } from "../../../../components/CustomSelectWField";
import { CustomInputWField } from "../../../../components/CustomInputWField";
import CustomDropzone from "../../../../components/CustomDropzone";

import ServicoAcolhimentoService from "../../../../../main/services/ServicoAcolhimentoService";
import MotivoSituacaoService from "../../../../../main/services/MotivoSituacaoService";
import ConfirmationModal from "./ConfirmationModal";
import { criancaFunc } from "../../../../../helpers/Funcionalidades";
import { IoHelpCircle } from "react-icons/io5";
import { mascaraNumeroGuia } from "../../../../utils/masks";

export const Movimentacao = ({
  props,
  dataMenor,
  dataFutura,
  dataNascimento,
  roleKeycloack,
  user,
}) => {
  const [servicos, setServicos] = useState({ options: [], isLoading: false });
  const [motivos, setMotivos] = useState({ options: [], isLoading: false });

  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const handleGetServicos = () => {
    setServicos({ ...servicos, isLoading: true });
    ServicoAcolhimentoService.getServicosAcolhimentoAtivosSuspensosLogado().then(
      (res) => {
        let filteredData = res.data.filter((item) => !!item.pessoaJuridica);

        if (roleKeycloack.includes(criancaFunc.cadastrarServico)) {
          filteredData = filteredData.filter((item) =>
            user.orgaoExterno?.includes(item.pessoaJuridica.id)
          );
        }

        setServicos({ options: filteredData, isLoading: false });
      }
    );
  };

  const handleGetMotivos = (dataMovimentacao) => {
    setMotivos({ ...motivos, isLoading: true });
    MotivoSituacaoService.pesquisarMotivoSituacao().then((res) => {
      let motivoSituacaoAcolhido = res.data
        .filter((item) => item.tipoSituacao.id === 1 && item.dataFim === null)
        .map((item) => {
          return item;
        });

      if (dataNascimento && dataMovimentacao) {
        const date = parse(dataNascimento, "dd/MM/yyyy", new Date());
        const dateMovimentacao = parse(
          dataMovimentacao,
          "dd/MM/yyyy",
          new Date()
        );

        const umAnoDepois = addYears(date, 1);
        const dentroUmAno = dateMovimentacao <= umAnoDepois;

        if (dentroUmAno) {
          setMotivos({ options: motivoSituacaoAcolhido, isLoading: false });
        } else {
          motivoSituacaoAcolhido = motivoSituacaoAcolhido.filter(
            (item) => item.extincaoPoderFamiliar !== "S"
          );
          setMotivos({ options: motivoSituacaoAcolhido, isLoading: false });
        }
      } else {
        setMotivos({ options: motivoSituacaoAcolhido, isLoading: false });
      }
    });
  };

  const handleConfirmAction = () => {
    props.setFieldValue("idMotivoSituacao", selectedOption);

    setIsConfirmationModalOpen(false);
  };

  return (
    <Group title="Movimentação">
      <Grid mt="15px" templateColumns="repeat(4, 1fr)" gap="25px" rowGap="20px">
        <GridItem colSpan={{ base: 3, sm: 3, lg: 1 }}>
          <CustomDatepickerWField
            fieldName="dataMovimentacao"
            label="Data*"
            placeholder="DD/MM/AAAA"
            maxDate={new Date()}
          />
          {dataMenor &&
            props.values.dataNascimento &&
            props.values.dataMovimentacao && (
              <Text
                mt="8px"
                color="#E53E3E"
                fontSize="sm"
                lineHeight={"normal"}
              >
                A data não pode ser menor que a data de nascimento.
              </Text>
            )}

          {dataFutura && props.values.dataMovimentacao && (
            <Text mt="8px" color="#E53E3E" fontSize="sm" lineHeight={"normal"}>
              A data informada não pode ser uma data futura!
            </Text>
          )}
        </GridItem>
        <GridItem colSpan={{ base: 3, sm: 3, lg: 2 }}>
          <CustomSelectWField
            fieldName="idServicoAcolhimento"
            label="Serviço de Acolhimento*"
            placeholder="Selecione o Serviço de Acolhimento"
            getOptionLabel={(option) => option?.pessoaJuridica?.nomeFantasia}
            getOptionValue={(option) => option.id}
            isLoading={servicos.isLoading}
            options={servicos.options}
            onChange={(value) => {
              props.setFieldValue("idServicoAcolhimento", value);
              props.setFieldValue("idBairroFamiliaAcolhedora", null);
              if (value?.tipoServicoAcolhimento?.regime !== "SAF") {
                props.setFieldValue("cpfFamiliaAcolhedora", "");
                props.setFieldValue("nomeFamiliaAcolhedora", "");
                props.setFieldValue("dataNascimentoFamiliaAcolhedora", "");
                props.setFieldValue("dataValidadeTermoGuarda", "");
                props.setFieldValue("idGeneroFamiliaAcolhedora", "");
              }
            }}
            onFocus={servicos.options.length === 0 ? handleGetServicos : null}
          />
        </GridItem>

        {/* <GridItem colSpan={{ base: 3, sm: 3, lg: 1 }}>
          <CustomSelectWField
            fieldName="tipoMotivoSituacao"
            label="Situação Atual*"
            placeholder="Selecione a Situação atual"
            options={[{ label: "Acolhido", value: "Acolhido" }]}
            isDisabled={true}
          />
        </GridItem> */}
        <GridItem colSpan={{ base: 3, sm: 3, lg: 2 }}>
          <CustomSelectWField
            fieldName="idMotivoSituacao"
            label="Motivo*"
            placeholder="Selecione o Motivo"
            getOptionLabel={(option) => option.descricao}
            getOptionValue={(option) => option.id}
            isLoading={motivos.isLoading}
            options={motivos.options}
            onChange={(value) => {
              setSelectedOption(value ? value : "");
              if (!!value) {
                setIsConfirmationModalOpen(true);
              } else {
                props.setFieldValue("idMotivoSituacao", value ? value : "");
              }
            }}
            onFocus={() => handleGetMotivos(props.values.dataMovimentacao)}
            limitado={true}
          />
        </GridItem>
        <GridItem colSpan={{ base: 3, sm: 3, lg: 2 }} />

        {props.values.idMotivoSituacao &&
          props.values.idMotivoSituacao.riscoVida === "S" && (
            <>
              <GridItem
                colSpan={{ base: 3, sm: 3, lg: 2 }}
                position={"relative"}
                w={"230px"}
              >
                <CustomSelectWField
                  fieldName="incluidoProgramaPPCAAM"
                  label="Incluído no Programa PPCAAM?*"
                  placeholder="Selecione"
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  isLoading={motivos.isLoading}
                  options={[
                    { label: "Sim", value: "S" },
                    { label: "Não", value: "N" },
                  ]}
                  onChange={(value) => {
                    props.setFieldValue(
                      "incluidoProgramaPPCAAM",
                      value ? value : ""
                    );
                  }}
                  limitado={true}
                />
                <Tooltip
                  label={
                    "O Programa de Proteção a Crianças e Adolescentes Ameaçados de Morte - PPCAAM, consiste em uma política de proteção à vida de crianças e adolescentes em ameaça iminente de morte."
                  }
                  fontSize="md"
                  textAlign={"justify"}
                >
                  <span
                    className="hint-tooltip"
                    style={{ position: "absolute", top: 0, left: "215px" }}
                  >
                    <Icon
                      aria-label="Aviso de pendente"
                      color="#6B6C71"
                      as={IoHelpCircle}
                      boxSize={{ base: "20px" }}
                    />
                  </span>
                </Tooltip>
              </GridItem>
              <GridItem colSpan={{ base: 3, sm: 3, lg: 2 }} />
            </>
          )}

        <GridItem colSpan={{ base: 3, sm: 3, lg: 1 }}>
          <CustomInputWField
            fieldName="numeroGuia"
            label={`Número da Guia${props.values.anexoGuia ? "*" : ""}`}
            maxLength={16}
            onChange={(e) =>
              props.setFieldValue(
                "numeroGuia",
                e.target.value ? mascaraNumeroGuia(e.target.value) : ""
              )
            }
            placeholder="Informe o Número da Guia"
          />
        </GridItem>
        <GridItem colSpan={{ base: 3, sm: 3, lg: 1 }}>
          <Flex>
            <CustomDropzone
              formProps={props}
              title="Anexar Guia"
              fieldName="anexoGuia"
              height="42px"
              titleText="Informe o número da guia"
            />
          </Flex>
        </GridItem>
        <GridItem colSpan={4}>
          <CustomInputWField
            fieldName="informacoesComplementares"
            label="Informações Complementares"
            placeholder="Informe as Informações Complementares"
            maxLength={150}
            messageLength={true}
          />
        </GridItem>
      </Grid>
      <ConfirmationModal
        isOpen={isConfirmationModalOpen}
        selectedOption={selectedOption}
        onClose={() => setIsConfirmationModalOpen(false)}
        onConfirm={handleConfirmAction}
      />
    </Group>
  );
};
